import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.seller}sanity/${COMMON_QUERY_PARAMS.SELLER_ID}/cancelSanityTests`;

export interface StartNewSanityTestArgs {
  sellerId: string;
}

const cancelSanityTest = async ({
  sellerId,
}: StartNewSanityTestArgs): Promise<
  BackResponse<boolean> | BackResponseFailure
> => {
  try {
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, sellerId);

    const response = await apiCall<BackResponse<boolean>>(url, {
      method: SUPPORTED_METHODS.PUT,
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
};

export default cancelSanityTest;
